'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$55() {
  this.bFP = null;
  this.bFQ = false;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$55 as $c_Lpresto_TwoFactorAuthView$$anon$55 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$55.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$55;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$55() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$55 as $h_Lpresto_TwoFactorAuthView$$anon$55 };
$h_Lpresto_TwoFactorAuthView$$anon$55.prototype = $p;
$p.P = (function() {
  if ((!this.bFQ)) {
    this.bFP = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T8($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$()));
    this.bFQ = true;
  }
  return this.bFP;
});
var $d_Lpresto_TwoFactorAuthView$$anon$55 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$55, "presto.TwoFactorAuthView$$anon$55", ({
  T1: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$55 as $d_Lpresto_TwoFactorAuthView$$anon$55 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$55.js.map
